// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../styles/styles.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Home-module_link_button_BLYMn {
  display: flex !important;
  flex-direction: column !important;
  align-items: center;
  justify-content: space-between;
  padding: 24px 20px 16px !important;
  width: 200px;
  height: 120px;
  line-height: 1.1;
}

.Home-module_link_button_BLYMn span {
  margin: 0 !important;
}

.Home-module_wide_link_button_HZQNq {
}

.Home-module_wide_link_button_HZQNq span {
  font-size: x-large;
  font-weight: 700;
}

.Home-module_section_title_zCBMd {
  padding-top: 6px;
  padding-left: 16px;
  padding-bottom: 16px;
}

.Home-module_sub_section_title_bslN7 {
  font-family: 'Montserrat', sans-serif;
  color: var(--uu-text);
  font-weight: 600;
  font-size: 20px;
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 0 12px 6px;
  width: 100%;
  text-align: center;
}

.Home-module_welcome_title_gFrpa {
  text-transform: uppercase;
  font-size: 22px;
  color: var(--uu-lake-powell);
  border-bottom: 2px solid var(--uu-utah-red);
}

.Home-module_nav_card_jJR9T {
  display: flex;
  flex-wrap: wrap;
  row-gap: 10px;
  column-gap: 16px;
  justify-content: center;
  overflow-y: auto;
  padding: 0 20px 10px;
}

.Home-module_link_div_t1uUe {
  display: flex;
  flex-wrap: wrap;
  row-gap: 10px;
  column-gap: 16px;
  justify-content: center;
}

.Home-module_break_KmseL {
  flex-basis: 100%;
  height: 0;
}

.Home-module_home_card_aWolw {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 36px;
  align-items: center;
  padding: 60px;
}

.Home-module_home_card_logged_in_pwSjd {
  padding: 0;
  gap: 10px;
}

.Home-module_app_desc_text_Bu6SQ {
  font-size: 16px;
  text-align: center;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
}

.Home-module_bos_footer_nM2mL {
  gap: 32px;
  padding: 12px;
}

.Home-module_footer_links_M7dSU {
}
`, "",{"version":3,"sources":["webpack://./src/client/routes/Home.module.css"],"names":[],"mappings":"AAAA;EAEE,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;EACnB,8BAA8B;EAC9B,kCAAkC;EAClC,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;AAEA;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EAEE,yBAAyB;EACzB,eAAe;EACf,4BAA4B;EAC5B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,aAAa;AACf;;AAEA;EAEE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EAEE,SAAS;EACT,aAAa;AACf;;AAEA;AAEA","sourcesContent":[".link_button {\n  composes: uu_button_white from 'Styles/styles.module.css';\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: center;\n  justify-content: space-between;\n  padding: 24px 20px 16px !important;\n  width: 200px;\n  height: 120px;\n  line-height: 1.1;\n}\n\n.link_button span {\n  margin: 0 !important;\n}\n\n.wide_link_button {\n  composes: bos_link from 'Styles/styles.module.css';\n}\n\n.wide_link_button span {\n  font-size: x-large;\n  font-weight: 700;\n}\n\n.section_title {\n  padding-top: 6px;\n  padding-left: 16px;\n  padding-bottom: 16px;\n}\n\n.sub_section_title {\n  font-family: 'Montserrat', sans-serif;\n  color: var(--uu-text);\n  font-weight: 600;\n  font-size: 20px;\n  margin-top: 20px;\n  margin-bottom: 10px;\n  padding: 0 12px 6px;\n  width: 100%;\n  text-align: center;\n}\n\n.welcome_title {\n  composes: sub_section_title;\n  text-transform: uppercase;\n  font-size: 22px;\n  color: var(--uu-lake-powell);\n  border-bottom: 2px solid var(--uu-utah-red);\n}\n\n.nav_card {\n  display: flex;\n  flex-wrap: wrap;\n  row-gap: 10px;\n  column-gap: 16px;\n  justify-content: center;\n  overflow-y: auto;\n  padding: 0 20px 10px;\n}\n\n.link_div {\n  display: flex;\n  flex-wrap: wrap;\n  row-gap: 10px;\n  column-gap: 16px;\n  justify-content: center;\n}\n\n.break {\n  flex-basis: 100%;\n  height: 0;\n}\n\n.home_card {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 36px;\n  align-items: center;\n  padding: 60px;\n}\n\n.home_card_logged_in {\n  composes: home_card;\n  padding: 0;\n  gap: 10px;\n}\n\n.app_desc_text {\n  font-size: 16px;\n  text-align: center;\n  font-family: 'Montserrat', sans-serif;\n  font-weight: 500;\n}\n\n.bos_footer {\n  composes: link_div;\n  gap: 32px;\n  padding: 12px;\n}\n\n.footer_links {\n  composes: bos_footer_link from 'Styles/styles.module.css';\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link_button": `Home-module_link_button_BLYMn ${___CSS_LOADER_ICSS_IMPORT_0___.locals["uu_button_white"]}`,
	"wide_link_button": `Home-module_wide_link_button_HZQNq ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bos_link"]}`,
	"section_title": `Home-module_section_title_zCBMd`,
	"sub_section_title": `Home-module_sub_section_title_bslN7`,
	"welcome_title": `Home-module_welcome_title_gFrpa Home-module_sub_section_title_bslN7`,
	"nav_card": `Home-module_nav_card_jJR9T`,
	"link_div": `Home-module_link_div_t1uUe`,
	"break": `Home-module_break_KmseL`,
	"home_card": `Home-module_home_card_aWolw`,
	"home_card_logged_in": `Home-module_home_card_logged_in_pwSjd Home-module_home_card_aWolw`,
	"app_desc_text": `Home-module_app_desc_text_Bu6SQ`,
	"bos_footer": `Home-module_bos_footer_nM2mL Home-module_link_div_t1uUe`,
	"footer_links": `Home-module_footer_links_M7dSU ${___CSS_LOADER_ICSS_IMPORT_0___.locals["bos_footer_link"]}`
};
export default ___CSS_LOADER_EXPORT___;
